/* The shared LIHL coin: St. Beer heads / raccoon-tail tails.
 * Palette sprites derived from the Coinflipper artwork; no image-loading race.
 * canvas(side, tone, size) and pixels(side, size): 16, 32 (default), or 64.
 * The toss uses the detailed face; small wallet icons use the 32px face.
 * Rebuild embedded art with scripts/arcade-coin-sprites.cjs.
 */
(function () {
    'use strict';
    /* SPRITE_DATA_START */
    var GOLD = ["#241706","#3b270e","#533714","#6c491b","#835a24","#9a6b2a","#b28035","#c39545","#d5a958","#e4ba6d","#edcd8a","#f8dda4","#ffedbd","#fff6d7"], SPRITES = {
  "16": {
    "heads": [
      "......5555......",
      "....73433435....",
      "...5463443644...",
      "..556445433654..",
      ".64566476366544.",
      ".46757244175754.",
      ".55556364264455.",
      "4464333542345543",
      "4446433344533443",
      ".54754398656544.",
      ".54644464444435.",
      ".44464376575443.",
      "..454437754454..",
      "...4454764544...",
      "....35333453....",
      "................"
    ],
    "tails": [
      "......5555......",
      "....63433435....",
      "...5444345544...",
      "..545485254544..",
      ".64553537753444.",
      ".44554345232344.",
      ".55555421688445.",
      "4455544234465443",
      "4455534864224443",
      ".54533337851344.",
      ".53447622561345.",
      ".44367762133443.",
      "..444245314454..",
      "...4442323544...",
      "....35333453....",
      "................"
    ]
  },
  "32": {
    "heads": [
      "..............5444..............",
      "..........489754446763..........",
      "........5953533333353473........",
      ".......856453444444344545.......",
      "......95444555365255554446......",
      ".....A344557346775437544436.....",
      "....875475455733325354574455....",
      "...74437874425254242337763344...",
      "..365555766446866753366655545...",
      "..9543665585426876135845552545..",
      "..6357755687534663336864576525..",
      ".545477766853556645248667774532.",
      ".655355667855497684337655443543.",
      ".933555346732565453237535254435.",
      ".834664517534245431435753266435.",
      ".744764532344246531332245566455.",
      ".744548531434343332344325455445.",
      ".734433351242267762221253554435.",
      ".544339782323299753243654243533.",
      ".3453446435739A9999565345543532.",
      "..5354284255555457744463542535..",
      "..6543764433549664453374353455..",
      "..2546637737439666638752647450..",
      "...54545676344966763776535544...",
      "....634546535487667157645345....",
      "....267454336687665135364461....",
      ".....2626553488555733644361.....",
      "......25446446666654453451......",
      "........4553523443253554........",
      ".........1464244343554..........",
      "............12333321............",
      "................................"
    ],
    "tails": [
      "..............5444..............",
      "..........489754446763..........",
      "........5953533433354473........",
      ".......856453322343344545.......",
      "......85443334624555444446......",
      ".....A344463387234554534436.....",
      "....875345437986411345553455....",
      "...74335554388533456434543344...",
      "..365545654375235898743554545...",
      "..9542555642532389732213453545..",
      "..6355555553322575333221445525..",
      ".545346555542125522245551453532.",
      ".655355555554224223789984343543.",
      ".933465555544431126888776144435.",
      ".834555555544433165556776344435.",
      ".744555555444321333322366334355.",
      ".744555554443467543322246334445.",
      ".733554444437899986422214344435.",
      ".545355543343346798852113143533.",
      ".345344442323322378774112243532.",
      "..5354542445432222576521144535..",
      "..6543442888884221256510343455..",
      "..2546334888887421125403436450..",
      "...54541676777763112214435554...",
      "....534354445665520124435345....",
      "....266452122355302445364461....",
      ".....2626451122313433644361.....",
      "......25435444433554453451......",
      "........4553523443253554........",
      ".........1464244333454..........",
      "............12333321............",
      "................................"
    ]
  },
  "64": {
    "heads": [
      "................................................................",
      ".........................01444444444400.........................",
      "......................058A9988888888888440......................",
      "...................03AAA86433333333234578763....................",
      "..................3AB8533173744554475533357872..................",
      "................0CB83183723045555554122739026780................",
      "..............17A742833256642223322255653326235740..............",
      ".............2A952553565323243297234233356435424771.............",
      "............3C7337157422455452A758253564324651922672............",
      "...........4B6291473157755462217601244557751373182473...........",
      "..........6A574365243788344604687640632387734256255474..........",
      ".........4A55337325664554237966666576324554665136325473.........",
      "........2B6272824556637517767875577655515626655337161561........",
      ".......0B676282478566265467312186131354354266487427174660.......",
      ".......88433725788856416231834487434602161465887743633364.......",
      "......4A36363378888834344238222761236315323387777624554372......",
      ".....0A572552637787637347117A877776861063373677763516445560.....",
      ".....791326256654874857247668988887655532748377346642622273.....",
      "....2B574734666654375864465433433333335435856345665534565560....",
      "....4933262456666556888422228A999897221148877456655442723272....",
      "...0A66582578356646598881663AA9AA988544078885645543874556464....",
      "...5924371777875417788855516441772242224387766245777761725262...",
      "...6815554777778656888846227303573134223278776377777774646162...",
      "..09641626777777776888843529877675777332177876467777775462365...",
      "..09472713337777776887636508AA9786AA82162378864677762242735460..",
      "..092635356655544768883881249954538851262277754333145552627360..",
      "..682563356665335568883550447674255642140677763322635553545273..",
      "..964363455565742177784152168632223442311577661287324554454364..",
      "..854372232232473165762353254374454240514167561216131322374344..",
      "..845373778861841456736261325366764420372416646736147776464444..",
      "..845273777747531426445624304547754402144205626545266666474344..",
      "..845273777515251631212385110548734114303202112265466666473444..",
      "..845273677247941922854361304126531141613124514180247665464444..",
      "..844372443499461722614263455611213643605654332361543343364353..",
      "..744363552845621820425412151975467725221214210942554444454353..",
      "..762563452763136627263122412577787443331515122812545543447273..",
      "..27254535339856A926614265405A58711652542220362724144453626261..",
      "..08373623427A97971573441217AAA999A554026723647437434442725360..",
      "..0755161663289673256288235B998B9888AA718663629147714652623650..",
      "...46485355133555115455860A99A9A9A9B998175665371575614364A262...",
      "...3722272265287614265387182433437989780363627526646321722261...",
      "...0757472272297536435325243875354828330354529326436504555740...",
      "....47233735327736741542354397657573633A21526724524542823272....",
      "....175527342845268262267454A8658665360550003504255324535650....",
      ".....572827236528582717873069865743747017999711155222816273.....",
      ".....075435525639475636742189865756858086558850355527433550.....",
      "......47282643347576344233299855856858027A9986372528527472......",
      "......0671837317656727145538986675685808743885464166561740......",
      ".......27543373555671614272897667568580248887545247333751.......",
      "........374562742456163366299777665848206556752267183561........",
      "........05741927613625327638A77866486202168653186371562.........",
      ".........047444457323333653796786658741253101573623563..........",
      "..........14744413663225625665565546552172137531626630..........",
      "...........04751961376423178A988878886433386319416630...........",
      "............047711211258840145777764214975101222762.............",
      ".............0366328864134677766667776431568615652..............",
      "...............1475346538222344444432227356326640...............",
      "................02576235653343375233336553266510................",
      "..................0256752222442762442212576420..................",
      "....................023566665443344666665210....................",
      ".......................013446666666643310.......................",
      "............................00000000............................",
      "................................................................",
      "................................................................"
    ],
    "tails": [
      "................................................................",
      ".........................0144444444440..........................",
      "......................157A9988888888878440......................",
      "...................03A9A86433333343334578763....................",
      "..................2BB8533273745555484633357872..................",
      "................0CB84084723045555554132738026780................",
      "..............18A742833256653222222255642326235740..............",
      ".............2A952553565322221121353322355425424761.............",
      "............3C83271574122422157223744553214741933672............",
      "...........4B5281473135431369721436446636431363082572...........",
      "..........6A574375233453146786124456465445544256245474..........",
      ".........5A55337324545420798874013364557455444246324472.........",
      "........2A5272732455563228899766200433474557455236161561........",
      ".......1B67628235564533279888785332210124443554623717465........",
      ".......88433724555465322989777333233445512545564532623264.......",
      "......4927363246555533277878523233355898731345455534554362......",
      ".....0A5725515546555730587832333245699988751355555515345550.....",
      ".....791326145554655441677333323479899895746135555542622273.....",
      "....2B574733655555655513666332237889966342322035555524565560....",
      "....49332625465555555423553232478897662223222113455552823272....",
      "...0A6657335555655544531143132258989323232332211445443456475....",
      "...5914271455554655544421431125767422233233222102545541725262...",
      "...6725553555555565555542022125665423322323324240255543646162...",
      "..09641624356555555555553101155553222223386977561144453352364...",
      "..094727155553755554745443101455211332778999998744263442735460..",
      "..092635255555555645545444410135312156679899987764035442617360..",
      "..682563355545555455455545443111111246797988889865224442545263..",
      "..964263334577555554654464434321012368989777878675314564444364..",
      "..854272455555445655444634433433025676787888877776203443364353..",
      "..845372455555555444455344443332046534243527776766503444364454..",
      "..844272455555555555443453344320343232333223657766503444364354..",
      "..844272344444444444434555433103332433332322237765512443364454..",
      "..845272455555555543356543202636622323232222223655503443364454..",
      "..845372455544466545443422479888875422223232222255413444364353..",
      "..745263445666533444443147888999899493332223121255504543454353..",
      "..762663233455554456221789889999889889643221221325413322447273..",
      "..272535355555456443327753433749997898865522212144214442626361..",
      "..082736244455544442163232332235489887887541111124033442725360..",
      "..076516145644554431432333323322635888778733111123035432623650..",
      "...464754235555473033242424232322287778787611111312443264A262...",
      "...3722272455455312332324232322221216876676531111134441723161...",
      "...075746234554430439667373322222222446766642111025433455574....",
      "....47233725544414688988988722222221156656654110134442923272....",
      "....17552732444407789789898883222211211566444101534424535650....",
      ".....572727244530888998898787751112121355553102344332826372.....",
      ".....075435524420787878787877766311211134542023543417433550.....",
      "......4728264232576777776678767652111112342033435328536572......",
      "......066183732167667767766676665211111320133544327655274.......",
      ".......27542373156564555766666655521111113344433256333751.......",
      "........374562733543223244566565542100113454435266183661........",
      "........04741936712111212243565543100234444343195371562.........",
      ".........047444447311122112335544102343734341473623663..........",
      "..........04744413663111121234442023344533247631626630..........",
      "...........047518613663111111233014334323476319416630...........",
      "............036711210257740112301232125875101222763.............",
      "..............267327864224676655556676431568614652..............",
      "...............1475345538222344444431227355326640...............",
      "................02576234553333275233336553266520................",
      "..................0256752222442752432322576420..................",
      "....................013566665443344666665210....................",
      ".......................013346666666643310.......................",
      "............................00000000............................",
      "................................................................",
      "................................................................"
    ]
  }
};
    /* SPRITE_DATA_END */
    var KEYS = '0123456789ABCDEF';
    var PAL = { o: '#281907', d: '#735025', m: '#bb8738', g: '#d1a04a', l: '#e9c379', h: '#ffebb3', w: '#fff5d7' };
    GOLD.forEach(function (colour, i) { PAL[KEYS[i]] = colour; });
    var canvasCache = {}, urlCache = {};
    function sizeOf(size) { return size === 16 || size === 64 ? size : 32; }
    function pixels(side, size) { return SPRITES[sizeOf(size)][side === 'tails' ? 'tails' : 'heads']; }
    function canvas(side, tone, size) {
        size = sizeOf(size); side = side === 'tails' ? 'tails' : 'heads';
        tone = tone === 'bright' || tone === 'dim' ? tone : 'normal';
        var key = side + ':' + tone + ':' + size;
        if (canvasCache[key]) return canvasCache[key];
        var cv = document.createElement('canvas'); cv.width = cv.height = size;
        var g = cv.getContext('2d'), rows = pixels(side, size), shift = tone === 'bright' ? 1 : tone === 'dim' ? -2 : 0;
        for (var y = 0; y < size; y++) for (var x = 0; x < size; x++) {
            var ch = rows[y][x]; if (ch === '.') continue;
            g.fillStyle = GOLD[Math.max(0, Math.min(GOLD.length - 1, KEYS.indexOf(ch) + shift))];
            g.fillRect(x, y, 1, 1);
        }
        return (canvasCache[key] = cv);
    }
    function dataUrl(glint, side) {
        side = side === 'tails' ? 'tails' : 'heads';
        var key = side + ':' + !!glint;
        if (urlCache[key]) return urlCache[key];
        try {
            if (!glint) return (urlCache[key] = 'url(' + canvas(side).toDataURL('image/png') + ')');
            var cv = document.createElement('canvas'); cv.width = cv.height = 32;
            var g = cv.getContext('2d'), rows = pixels(side);
            for (var y = 0; y < 32; y++) for (var x = 0; x < 32; x++) {
                var ch = rows[y][x], k = x - y;
                if (ch === '.' || KEYS.indexOf(ch) < 6 || k < 4 || k > 8) continue;
                g.fillStyle = k === 4 || k === 8 ? 'rgba(255,238,191,.3)' : 'rgba(255,249,220,.8)';
                g.fillRect(x, y, 1, 1);
            }
            return (urlCache[key] = 'url(' + cv.toDataURL('image/png') + ')');
        } catch (e) { return 'none'; }
    }
    function applyCss(el) {
        el.style.setProperty('--ak-coin-img', dataUrl(false));
        el.style.setProperty('--ak-coin-glint', dataUrl(true));
        el.style.setProperty('--ak-coin-tails', dataUrl(false, 'tails'));
    }
    function walletChanged() {
        try { sessionStorage.removeItem('arcade_wallet_v1'); } catch (e) { /* private mode */ }
        try { window.dispatchEvent(new Event('arcade-coins-changed')); } catch (e) { /* old browser */ }
        try { localStorage.setItem('arcade_wallet_ping', String(Date.now())); } catch (e) { /* private mode */ }
    }
    window.ArcadeCoin = { version: 'st-beer-1', PAL: PAL, pixels: pixels, canvas: canvas, dataUrl: dataUrl, applyCss: applyCss, walletChanged: walletChanged };
})();
